<template>
    <fieldset class="form-group">
        <legend class="col-form-label">Parks :</legend>

        <div v-for="park in parks" v-bind:key="park.id"  class="form-check my-2">
            <input type="checkbox"
                   :id="'parkCheck' + park.id"
                   class="form-check-input"
                   :value="park.id"
                   name="parks[]"
                   :checked="park.isSelected" />
              <label
                :for="'parkCheck' + park.id"
                class="form-check-label">
                {{park.name}}
                <span v-if="park.default">(default)</span>
                <span v-if="park.ownerable_type === 'App\\Models\\Tour'" class="badge badge-info d-inline">guest</span>
              </label>
        </div>
    </fieldset>
</template>

<script>
    export default {
        props: {
            availableParks : {
                type: Array,
            },
            selectedParks : {
                type: Array,
                default: () => [],
            },
        },
        computed: {
            parks() {
                let vm = this;
                return _.map(this.availableParks, function (park) {
                    if (vm.selectedParks.length === 0) {
                        park.isSelected = park.default;
                    } else {
                        park.isSelected = !_.isUndefined(_.find(vm.selectedParks, {id: park.id}));
                    }
                    return park;
                })
            },
        }
    }
</script>

<style scoped>

</style>